import { Component } from '@verndale/core';
import Cookies from 'js-cookie';

class Module extends Component {
  setupDefaults() {
    this.shouldDisplayAlert();
    this.getAlert();
  }

  async getAlert(){
    try {
      const alert = await fetch(`${this.el.dataset.alertEndpoint}`)
      const response = await alert.json();
      this.alertList = response;
      this.renderAlert();
    } catch (e){
      this.alertList = []
      this.el.remove();
    }
  }

  renderAlert(){
    const alertElement = this.alertList.map(el => {
      /* eslint-disable indent */
      return `
        <div class="alert__wrapper" data-id="${el.Id}">
          <div class="container alert__inner">
            ${el.Discardable ?
              `<button class="alert__close-btn" aria-label="Close Alert Baner">
                <svg viewBox="0 0 24 24" width="18" height="18" role="presentation">
                  <use xlink:href="#close"></use>
                </svg>
              </button>` : ''}
            
            <div class="alert__icon">
              <img src="${el.Icon.Src}" alt="${el.Icon.Alt}"/>
            </div>
            <div role="region" class="alert__content" aria-label="${el.Heading}">
              ${el.Heading &&
                `<h5 class="alert__title">${el.Heading}</h5>`}
              <div class="alert__description body-copy--secondary rtf">
                ${el.Copy}
              </div>
            </div>
          </div>
        </div>
      `
    }).join('')
    this.el.innerHTML = alertElement
    this.dom.$closeBtn = this.el._$$('.alert__close-btn')
    this.dom.$closeBtn?.map(el => {
      el._on('click', this.handleClose.bind(this));
    })
    this.shouldDisplayAlert()
    this.cleanAlerts();
  }

  handleClose(e) {
    e.preventDefault();
    const alert = e.target.closest('.alert__wrapper')
    const id = alert.dataset.id
    this.alerts.push(id);
    Cookies.set('sunrise_alert', JSON.stringify(this.alerts), { expires: 365 });
    alert.remove();
    this.cleanAlerts();
  }

  shouldDisplayAlert() {
    this.alerts = Cookies.get('sunrise_alert');

    if (this.alerts) {
      this.alerts = JSON.parse(this.alerts);
      const alerts = this.el._$$('.alert__wrapper')
      alerts.map(el => {
        const id = el.dataset.id
        if (this.alerts.includes(id)) {
          return el.remove();
        }
      })
    } else {
      this.alerts = [];
    }

    this.el.style.display = 'block';
  }

  cleanAlerts(){
    const alerts = this.el._$$('.alert__wrapper')
    if (alerts.length === 0){
      this.el.remove();
    }
  }
}

export default Module;
